import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  AfterPlay,
  DialogService,
  InsightType,
  Play,
  PlayService,
  RobotService,
  Solutions,
  Store
} from '@ng-cloud/badger-core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
    selector: 'bt-play-outputs-form',
    templateUrl: './play-outputs-form.component.html',
    styleUrls: ['./play-outputs-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PlayOutputsFormComponent implements OnInit {
  Play = Play;
  AfterPlay = AfterPlay;
  InsightType = InsightType;

  formGroup: UntypedFormGroup;
  robotId: number;
  play: Play;
  store: Store;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PlayOutputsFormComponent>,
    public dialogService: DialogService,
    public robotService: RobotService,
    public playService: PlayService,
  ) {
  }

  ngOnInit() {
    this.robotId = this.data.id;
    this.play = this.data.play;
    this.store = this.data.store;

    this.formGroup = this.createFormGroup();
  }

  createFormGroup(): UntypedFormGroup {
    const formGroup = new UntypedFormGroup({
      shelfDistanceDelta: new UntypedFormControl(),
      afterPlay: new UntypedFormControl(null, Validators.required)
    });

    switch (this.play.playType) {
      case Play.TYPE_INSIGHT:
        formGroup.addControl('insightOutputs', new UntypedFormGroup({
          hole_oos: new UntypedFormControl(),
          eOOS: new UntypedFormControl(),
          price_mismatch: new UntypedFormControl(),
          sale_price_mismatch: new UntypedFormControl(),
          top_stock: new UntypedFormControl()
        }));
        break;
    }

    return formGroup;
  }

  getPlayOutputs(): any[] {
    if (this.play.playType === Play.TYPE_INSIGHT) {
      return _.compact(_.map(this.formGroup.value.insightOutputs, (value, key) => value ? key : null));
    }

    return null;
  }

  getShelfDistanceDelta(): number {
    const delta = parseFloat(this.formGroup.value.shelfDistanceDelta);
    return isNaN(delta) ? 0.0 : delta;
  }

  runPlay() {
    const params = {
      'play_outputs': this.getPlayOutputs(),
      'shelf_distance_delta': this.getShelfDistanceDelta(),
      'after_play': this.formGroup.value.afterPlay
    };

    this.dialogRef.close();

    if (this.robotId) {
      this.robotService.runPlay(this.robotId, this.play.id, params).subscribe(() => {
        this.dialogService.alert(`Run Play command sent for:  '${this.play.name}'\nTrack progress on the Robot Commands page.`);
      });
    } else {
      this.playService.queuePlay(this.play).subscribe(playExecution => {
        this.dialogService.alert(`Store '${this.store.name}' queued the play:  '${this.play.name}'`);
        this.dialogService.alert(`Queued play:  '${this.play.name}'`);
      });
    }
  }

  protected readonly Solutions = Solutions;
}
